import { Route, Routes } from "react-router-dom";
import { DefaultTemplatesProvider } from "../../../contexts/DefaultTemplatesContext";
import { TemplatesOverview } from "./TemplatesOverview";
import { CreateTemplate } from "./CreateTemplate";
import { EditTemplate } from "./EditTemplate";

export const DefaultTemplatesRoutes = () => {
  return (
    <DefaultTemplatesProvider>
      <Routes>
        <Route path="/" element={<TemplatesOverview />} />
        <Route path="/new" element={<CreateTemplate />} />
        <Route path=":templateId" element={<EditTemplate />} />
      </Routes>
    </DefaultTemplatesProvider>
  );
};
